import _classCallCheck from "/builds/canvas-logic/joka/packages/web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/canvas-logic/joka/packages/web/node_modules/@babel/runtime/helpers/esm/createClass";
export var LanguageService = /*#__PURE__*/function () {
  function LanguageService() {
    _classCallCheck(this, LanguageService);

    this.lang = '';
  }

  _createClass(LanguageService, [{
    key: "getLanguage",
    value: function getLanguage() {
      return this.lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      this.lang = lang;
    }
  }, {
    key: "translate",
    value: function translate(mlstring, lang) {
      var value = mlstring.value;

      if (typeof value === 'string') {
        return value;
      }

      var langToUse = lang !== null && lang !== void 0 ? lang : this.lang;

      if (langToUse in value) {
        return value[langToUse];
      } else {
        console.error("Missing translation of ".concat(JSON.stringify(value), " for ").concat(langToUse, " language"));
        return '-';
      }
    }
  }, {
    key: "translateOptional",
    value: function translateOptional(mlString) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var lang = arguments.length > 2 ? arguments[2] : undefined;
      return mlString == null ? defaultValue : this.translate(mlString, lang);
    }
  }]);

  return LanguageService;
}();